import { Routes } from '@angular/router';
import { ROUTES } from '@core/constants/routes.config';
import { DattestComponent } from '@shared/components/dattest/dattest.component';
import { AdminLayoutComponent } from '@shared/layouts/admin-layout/admin-layout.component';

export const APP_ROUTES: Routes = [
  // {
  //   path: `${ROUTES.FAQ_MODULE}/:moduleName`,
  //   children: [
  //     {
  //       path: ROUTES.FAQ_ASSISTANT,
  //       loadComponent: () =>
  //         import('./modules/faq-assistant/faq-assistant.component').then(
  //           ({ FaqAssistantComponent }) => FaqAssistantComponent
  //         ),
  //     },
  //   ],
  // },
  {
    path: '',
    loadComponent: () =>
      import('./modules/faq-assistant/faq-assistant.component').then(
        ({ FaqAssistantComponent }) => FaqAssistantComponent
      ),
  },
  // {
  //   path: 'dattest',
  //   component: DattestComponent
  // },
  // {
  //   path: '',
  //   component: AdminLayoutComponent,
  //   children: [
  //     {
  //       path: `${ROUTES.FAQ_MODULE}/:moduleName`,
  //       children: [
  //         {
  //           path: ROUTES.FAQ_ASSISTANT,
  //           loadComponent: () =>
  //             import('./modules/faq-assistant/faq-assistant.component').then(
  //               ({ FaqAssistantComponent }) => FaqAssistantComponent
  //             ),
  //         },
  //       ],
  //     },
  //   ]
  // }
  {
    path: '**',
    title: 'Page Not Found',
    loadComponent: () =>
      import('./shared/layouts/page-not-found/page-not-found.component').then(
        ({ PageNotFoundComponent }) => PageNotFoundComponent
      ),
  },
];
